'use client';

import { ReactNode } from 'react';

import OrganizationImage from '../organization-image';

interface Props {
  children: ReactNode;
  organization: any;
}

const Organization = ({ children, organization }: Props) => {
  const { fileSources } = organization;

  const hasImage = Object.keys(fileSources).length > 0;

  return (
    <div className="flex flex-row p-2">
      {hasImage && (
        <div className="flex pr-2 w-2/5">
          <OrganizationImage fileSources={fileSources} />
        </div>
      )}
      <div>{children}</div>
    </div>
  );
};

export default Organization;
